/**
 * Adds zero-width spaces before each dot and slash in a URL to allow line breaks at these points.
 *
 * @param {string} url - The URL to be processed.
 * @returns {string} The processed URL with zero-width spaces added before each dot and slash, or the original string if it's invalid.
 */

export function addBreaksToUrl(url) {
  try {
    const { protocol, hostname, pathname } = new URL(url);

    // Add zero-width spaces before each dot and slash in the hostname and pathname
    const brokenHostname = hostname.split(".").join("\u200B.");
    const brokenPathname = pathname.split("/").join("\u200B/");

    // Construct and return the processed URL
    return `${protocol}//\u200B${brokenHostname}${brokenPathname}`;
  } catch (error) {
    // If the URL is invalid, return it unmodified
    return url;
  }
}
